import React from 'react'
import ContactInfo from '../components/ContactInfo'
import Form from '../components/Form'

const Contact = () => {
    return (
        <section>
            <h1 className="transition transform duration-300 ease-in-out text-center text-4xl text-indigo-700 font-semibold font_poppins hover:scale-105">Contact with us</h1>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mt-12">
                <div className="col-span-2">
                    <Form />
                </div>
                <div className="col-span-1">
                    <ContactInfo />
                </div>
            </div>
        </section>
    )
}

export default Contact
